import { NgModule } from '@angular/core';

import { CmpsTeamsCallCallDialogModule } from './call-dialog';
import { CmpsTeamsCallCallHudModule } from './call-hud';
import {
    CallStatusService,
    ChatStatusService,
    TranscriptService,
} from './core';
import { SocketService } from './core/socket.service';

@NgModule({
    imports: [CmpsTeamsCallCallDialogModule, CmpsTeamsCallCallHudModule],
    providers: [
        CallStatusService,
        ChatStatusService,
        SocketService,
        TranscriptService,
    ],
})
export class CmpsTeamsCallModule {}
